(function () {
  'use strict';

  function initSlider(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.slider-hero__slide'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('.slider-hero__dot'));
    var prevBtn = root.querySelector('.slider-hero__nav--prev');
    var nextBtn = root.querySelector('.slider-hero__nav--next');
    var playPauseBtn = root.querySelector('.slider-hero__playpause');

    if (slides.length <= 1) return;

    var current = 0;
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    var isPlaying = autoplay;

    function goTo(index) {
      index = (index + slides.length) % slides.length;
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isPlaying) return;
      timer = setInterval(next, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        startAutoplay();
      });
    });

    if (playPauseBtn) {
      var iconPause = playPauseBtn.querySelector('.icon-pause');
      var iconPlay = playPauseBtn.querySelector('.icon-play');

      playPauseBtn.addEventListener('click', function () {
        isPlaying = !isPlaying;

        if (isPlaying) {
          playPauseBtn.setAttribute('data-state', 'playing');
          playPauseBtn.setAttribute('aria-label', 'Pause slideshow');
          if (iconPause) iconPause.style.display = '';
          if (iconPlay) iconPlay.style.display = 'none';
          startAutoplay();
        } else {
          playPauseBtn.setAttribute('data-state', 'paused');
          playPauseBtn.setAttribute('aria-label', 'Play slideshow');
          if (iconPause) iconPause.style.display = 'none';
          if (iconPlay) iconPlay.style.display = '';
          stopAutoplay();
        }
      });
    }

    // Pause on hover, resume on mouse leave (desktop only)
    root.addEventListener('mouseenter', function () {
      if (isPlaying) stopAutoplay();
    });

    root.addEventListener('mouseleave', function () {
      if (isPlaying) startAutoplay();
    });

    // Basic swipe support for touch devices
    var touchStartX = 0;
    var viewport = root.querySelector('.slider-hero__viewport');

    if (viewport) {
      viewport.addEventListener(
        'touchstart',
        function (e) {
          touchStartX = e.changedTouches[0].screenX;
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchend',
        function (e) {
          var touchEndX = e.changedTouches[0].screenX;
          var diff = touchEndX - touchStartX;

          if (Math.abs(diff) > 40) {
            if (diff < 0) {
              next();
            } else {
              prev();
            }
            startAutoplay();
          }
        },
        { passive: true }
      );
    }

    startAutoplay();

    // Re-init support for Shopify theme editor (section reloads)
    document.addEventListener('shopify:section:unload', function (event) {
      if (event.target.contains(root)) {
        stopAutoplay();
      }
    });
  }

  function initAll() {
    var sliders = document.querySelectorAll('.slider-hero');
    sliders.forEach(initSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var slider = event.target.querySelector('.slider-hero');
    if (slider) initSlider(slider);
  });
})();